export default $client => ({
  get() {
    return $client.get('identity-limit');
  }
});
